import theme from 'ThemeProvider/theme';
import createSx from 'utils/createSx';

export default createSx({
  container: {
    padding: 3,
  },
  orderCard: {
    width: '100%',
    mb: 2,
    boxShadow: 1,
    '&:hover': {
      boxShadow: 2,
      cursor: 'pointer',
    },
  },
  orderHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    mb: 2,
  },
  orderNumber: {
    fontWeight: 'bold',
    color: 'primary.main',
  },
  orderDate: {
    color: 'text.secondary',
    fontSize: '0.875rem',
  },
  productImage: {
    objectFit: 'contain',
    backgroundColor: theme.palette.grey[100],
  },
  orderTotal: {
    fontWeight: 'bold',
    color: 'primary.main',
    fontSize: '1.25rem',
  },
  orderItems: {
    color: 'text.secondary',
    fontSize: '0.875rem',
  },
  statusContainer: {
    display: 'flex',
    gap: 1,
    flexWrap: 'wrap',
    mt: 1,
  },
  emptyState: {
    textAlign: 'center',
    py: 4,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    p: 3,
  },
});
